import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
// Pages
import { Home } from './pages/Home';
import { About } from './pages/About';
import { ProviSystem } from './pages/ProviSystem';
import { Workshop } from './pages/Workshop';
import { ProviSprint } from './pages/ProviSprint';
import { QuarterlyMeeting } from './pages/QuarterlyMeeting';
import { TeamTraining } from './pages/TeamTraining';
import { Contact } from './pages/Contact';
import { FreeResources } from './pages/FreeResources';
import { Masterclass } from './pages/Masterclass';
import { Testimonials } from './pages/Testimonials';
import { Magazin } from './pages/Magazin';
import { ProviToolkit } from './pages/ProviToolkit';
export function App() {
  return <Router data-id="element-0" data-mp="28sl3gxardmez">
      <div className="flex flex-col min-h-screen" data-id="element-1" data-mp="28sbar1ybx15l">
        <Header data-id="element-2" data-mp="23w4c7u89irxo" />
        <main className="flex-grow" data-id="element-3" data-mp="23ujho4ly78zt">
          <Routes data-id="element-4" data-mp="23ti67z10skhk">
            <Route path="/" element={<Home data-id="element-6" data-mp="3iiweonbohg2p" />} data-id="element-5" data-mp="3ik7k0rkruvvx" />
            <Route path="/despremine" element={<About data-id="element-8" data-mp="3mljaezbgzl56" />} data-id="element-7" data-mp="3ijfthv617oci" />
            <Route path="/provisystem" element={<ProviSystem data-id="element-10" data-mp="3mjzu58ptda3e" />} data-id="element-9" data-mp="3ml17jjuay8oa" />
            <Route path="/provitoolkit" element={<ProviToolkit data-id="element-12" data-mp="3rbzomln47asl" />} data-id="element-11" data-mp="3mj6jhwnqi0fz" />
            <Route path="/magazin" element={<Magazin data-id="element-14" data-mp="3relwkmdx3sbc" />} data-id="element-13" data-mp="3rcsxbs5mwadd" />
            <Route path="/workshop" element={<Workshop data-id="element-16" data-mp="5gez9t0lqvv" />} data-id="element-15" data-mp="6hpnd64cbd2" />
            <Route path="/provisprint" element={<ProviSprint data-id="element-18" data-mp="2zllduyaeeel5" />} data-id="element-17" data-mp="82ohezguggq" />
            <Route path="/sedintatrimestriala" element={<QuarterlyMeeting data-id="element-20" data-mp="33mou3lwcycmw" />} data-id="element-19" data-mp="2zmemy5wtxg6g" />
            <Route path="/trainingpersonalizat" element={<TeamTraining data-id="element-22" data-mp="33orik1hv3xpi" />} data-id="element-21" data-mp="33lx0uhq8gqzs" />
            <Route path="/contact" element={<Contact data-id="element-24" data-mp="38kqfwel64q22" />} data-id="element-23" data-mp="38m1fe27kzbnd" />
            <Route path="/resursegratuite" element={<FreeResources data-id="element-26" data-mp="3dkl60fx4dbm2" />} data-id="element-25" data-mp="38kgm0fx05yr3" />
            <Route path="/evenimenteonline" element={<Masterclass data-id="element-28" data-mp="3dii3wxiozs0z" />} data-id="element-27" data-mp="3dlntedv8gvx8" />
            <Route path="/testimoniale" element={<Testimonials data-id="element-30" data-mp="nv0z3w0wmu6q" />} data-id="element-29" data-mp="nw2ak1lu1ioz" />
          </Routes>
        </main>
        <Footer data-id="element-31" data-mp="su43rfcz2ye6" />
      </div>
    </Router>;
}